import { apiBase } from '../utils/apiBase.js'

// Falls du ein Token hast:
let authToken = null;

// Funktion zum Setzen/Updaten des Tokens
export function setAuthToken(token) {
  authToken = token;
}

// Custom Fetch Wrapper
export async function apiFetch(path, options = {}) {
  const url = apiBase() + '/api' + path;

  const headers = {
    "Content-Type": "application/json",
    ...(authToken ? { Authorization: `${authToken}` } : {}),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  // Automatisch Fehler werfen bei non-200 Status
  if (!response.ok) {
    const errorText = response.text? await response.text(): 'No additional error information';
    throw new Error(`API Error ${response.status}: ${errorText}`);
  }

  // Bei 204 gibt es keinen Body
  if (response.status === 204) return null;

  return response.json();
}
